var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrayCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.946,
    x2: 0.049,
    y2: 0.949,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939ea5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3307",
    "data-name": "Group 3307",
    transform: "translate(-392 -212)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1141",
    "data-name": "Rectangle 1141",
    width: 24,
    height: 24,
    rx: 4,
    transform: "translate(392 212)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-payment",
    "data-name": "Icon material-payment",
    d: "M17.473,6H4.608a1.6,1.6,0,0,0-1.6,1.608L3,17.257a1.6,1.6,0,0,0,1.608,1.608H17.473a1.6,1.6,0,0,0,1.608-1.608V7.608A1.6,1.6,0,0,0,17.473,6Zm0,11.257H4.608V12.432H17.473Zm0-8.041H4.608V7.608H17.473Z",
    transform: "translate(392.96 211.567)",
    fill: "#f3f3f3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCalendarIcon);
export default __webpack_public_path__ + "static/media/GrayCalendarIcon.c392bce52c013fbed9dcb1dc287ca523.svg";
export { ForwardRef as ReactComponent };